import { useSelector } from "react-redux";

import { CrmApplicationStatus, CrmApplicationStatusOrder } from "../models/crmStatus";
import { Programs } from "../models/programsConfig";
import {
  IdAzureApplicationStep,
  IdAzureApplicationStepsOrder,
  IdXboxApplicationStep,
  IdXboxApplicationStepsOrder,
  PitchApplicationStep,
  PitchApplicationStepsOrder,
} from "../models/status";
import {
  getIdAzureApplicationStep,
  getIdXboxApplicationStep,
  getPitchApplicationStep,
} from "../redux/selectors";
import { getOnboardingSignedIn } from "../redux/selectors/authSelectors";

export const compareCrmApplicationStatus = (
  sub1: CrmApplicationStatus,
  sub2: CrmApplicationStatus
) => {
  const indexSub1 = CrmApplicationStatusOrder.indexOf(sub1);
  const indexSub2 = CrmApplicationStatusOrder.indexOf(sub2);
  return indexSub1 < indexSub2 ? -1 : indexSub1 > indexSub2 ? 1 : 0;
};

export type ComponentLockRule = {
  program: Programs;
  step: IdXboxApplicationStep | IdAzureApplicationStep | PitchApplicationStep;
};

export const useIsComponentLocked = (lockRule?: ComponentLockRule): boolean => {
  const currentIdXboxStep = useSelector(getIdXboxApplicationStep);
  const currentIdAzureStep = useSelector(getIdAzureApplicationStep);
  const currentPitchStep = useSelector(getPitchApplicationStep);
  const isSignedIn = useSelector(getOnboardingSignedIn);

  if (!lockRule) {
    return false;
  }

  if (!isSignedIn) {
    // For now, being signed in for these components is a must regardless
    return true;
  }

  if (lockRule.program === Programs.IdXbox) {
    // ID@Xbox
    return (
      currentIdXboxStep === undefined ||
      (lockRule !== undefined &&
        IdXboxApplicationStepsOrder.indexOf(lockRule.step as IdXboxApplicationStep) >
          IdXboxApplicationStepsOrder.indexOf(currentIdXboxStep))
    );
  } else if (lockRule.program === Programs.IdAzure) {
    // ID@Azure
    return (
      currentIdAzureStep === undefined ||
      (lockRule !== undefined &&
        IdAzureApplicationStepsOrder.indexOf(lockRule.step as IdAzureApplicationStep) >
          IdAzureApplicationStepsOrder.indexOf(currentIdAzureStep))
    );
  }

  // Pitch
  return (
    currentPitchStep === undefined ||
    (lockRule !== undefined &&
      PitchApplicationStepsOrder.indexOf(lockRule.step as PitchApplicationStep) >
        PitchApplicationStepsOrder.indexOf(currentPitchStep))
  );
};
